import { Routes } from '@angular/router';
import { EpicGuard } from './core/guards/epic.guard';
import { EpnGuard } from './core/guards/epn.guard';
import { MemberGuard } from './core/guards/member.guard';
import { RxRegulatorGuard } from './core/guards/rxregulator.guard';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'signout',
    loadComponent: () => import('./core/components').then(m => m.LogoutComponent)
  },
  {
    path: 'signin',
    pathMatch: 'full',
    redirectTo: '/'
  },
  {
    path: 'signup',
    loadComponent: () => import('./core/components/auth/signup.component').then(m => m.SignupComponent)
  },
  {
    path: 'signout-complete',
    loadComponent: () => import('./core/components/logout-complete.component').then(m => m.LogoutCompleteComponent)
  },
  {
    path: 'signout-coordinator',
    loadComponent: () => import('./core/components').then(m => m.LogoutCoordinatorComponent)
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./overview/overview.component').then(m => m.OverviewComponent),
    canActivate: [AuthGuard, MemberGuard]
  },
  {
    path: 'clinical',
    pathMatch: 'full',
    loadComponent: () => import('./clinical/clinical.component').then(m => m.ClinicalComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'purchasing/rebates',
    pathMatch: 'prefix',
    loadComponent: () => import('./purchasing/rebates/rebates.component').then(m => m.RebatesComponent),
    canActivate: [AuthGuard, MemberGuard, EpicGuard]
  },
  {
    path: 'purchasing/wholesaler-compliance',
    pathMatch: 'full',
    loadComponent: () => import('./purchasing/wholesaler-compliance/wholesaler-compliance.component').then(m => m.WholesalerComplianceComponent),
    canActivate: [AuthGuard, MemberGuard, EpicGuard]
  },
  {
    path: 'reimbursements/epn-payments',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/epn-payments/epn-payments.component').then(m => m.EpnPaymentsComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard, RxRegulatorGuard]
  },
  {
    path: 'reimbursements/epn-payments/epn-payment-details/:paymentId',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/epn-payments/epn-payment-details.component').then(m => m.EpnPaymentDetailsComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard, RxRegulatorGuard]
  },
  {
    path: 'reimbursements/payment-reports',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/payment-reports/payment-reports.component').then(m => m.PaymentReportsComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/escrow',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/escrow/escrow.component').then(m => m.EscrowComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/escrow/escrow-accounts/:contractId',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/escrow/escrow-accounts.component').then(m => m.EscrowAccountsComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/enhanced-reconciliation',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/enhanced-reconciliation/enhanced-reconciliation.component').then(m => m.EnhancedReconciliationComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard, RxRegulatorGuard]
  },
  {
    path: 'reimbursements/ar-and-tax-reporting',
    pathMatch: 'full',
    loadComponent: () => import('./reimbursements/accounts-receivable/accounts-receivable.component').then(m => m.AccountsReceivableComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard, RxRegulatorGuard]
  },
  {
    path: 'reimbursements/accounting-reports',
    pathMatch: 'full',
    loadComponent: () => import('./reimbursements/accounting-reports/accounting-reports.component').then(m => m.AccountingReportsComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/reimbursed-below-cost',
    pathMatch: 'full',
    loadComponent: () => import('./reimbursements/reimbursed-below-cost/reimbursed-below-cost.component').then(m => m.ReimbursedBelowCostComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/reimbursed-below-cost/ticket',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/reimbursed-below-cost/rbc-ticket.component').then(m => m.RbcTicketComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/reimbursed-below-cost/ticket/:ticket_id',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/reimbursed-below-cost/rbc-ticket.component').then(m => m.RbcTicketComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/pac-lookup',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/pac-lookup/pac-lookup.component').then(m => m.PacLookupComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/pac-lookup/:ndc',
    pathMatch: 'prefix',
    loadComponent: () => import('./reimbursements/pac-select/pac-select.component').then(m => m.PacSelectComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'reimbursements/mfp-program',
    pathMatch: 'full',
    loadComponent: () => import('./reimbursements/mfp-program/mfp-program.component').then(m => m.MfpProgramComponent),
    canActivate: [AuthGuard, MemberGuard, EpnGuard]
  },
  {
    path: 'report-queue-history',
    pathMatch: 'full',
    loadComponent: () => import('./shared/components/report-queue/report-queue-history.component').then(m => m.ReportQueueHistoryComponent),
    canActivate: [AuthGuard, MemberGuard]
  },
  {
    path: '**',
    redirectTo: '/'
  },
];
